/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import configApi from '../../../config/api'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Text from '../../commons/Text/Text'
import Flex from '../../commons/Flex/Flex'
import { setAccessToken } from '../../../integration/request'
import { request } from '../../../integration'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import DashboardBoldBI from '../../commons/DashboardBoldbi/DashboardBoldBi'

const PANEL_BS = '65'
const PANEL_BS_ANALITICS = '67'

const PANEL_VEICULOS = '66'
const PANEL_VEICULOS_ANALITICS = '68'

const Dashboard = ({
  match: {
    params: { roleId }
  }
}) => {
  const [dashboard, setDashboard] = useState()
  const [config, setConfig] = useState()
  const [loading, setLoading] = useState(false)

  // request by Edson at 01/02/23
  const canSeeDashboard = false

  useEffect(() => {
    async function loadDashboard() {
      setLoading(true)
      try {
        const { data } = await request.get(
          `/v1/boldbi-dashboard/${roleId}/platform/${process.env.PLATFORM_WEB}`
        )
        setDashboard(data)
      } catch (err) {
        toast.error('Painel não encontrado')
      } finally {
        setLoading(false)
      }
    }

    if (canSeeDashboard) {
      loadDashboard()
    }

    return () => {
      const instance = BoldBI.getInstance('dashboard-container')
      if (instance) instance.destroy()
    }
  }, [roleId, canSeeDashboard])

  useEffect(() => {
    if (dashboard && dashboard.dashboardSiteUrl && dashboard.dashboardId) {
      setConfig({
        serverUrl: dashboard.dashboardSiteUrl,
        dashboardId: dashboard.dashboardId,
        authorizationServer: {
          url: `${configApi.baseURL}/v1/boldbi-dashboard/${roleId}/authorize`,
          headers: {
            'x-api-key': configApi.headers.XKey,
            ...setAccessToken()
          }
        }
      })
    }
  }, [dashboard])

  return (
    <DefaultLayout hiddenSearch>
      {loading && <LoadingBounce />}
      {canSeeDashboard && config && (
        <DashboardBoldBI id="dashboard-container" config={config} />
      )}
      {!canSeeDashboard && (
        <Flex
          style={{ flexDirection: 'column' }}
          alignItems="center"
          justifyContent="center"
        >
          <Text>Erro</Text>
          <div style={{ padding: 10 }} />
          <Text>Ocorreu uma falha no processamento de dados.</Text>
        </Flex>
      )}
    </DefaultLayout>
  )
}

Dashboard.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      roleId: PropTypes.string
    })
  }).isRequired
}

export default Dashboard
